import { createContext } from 'react';

import { User } from '../../shared/models/user.model';

export interface UserContextValue {
   user: User | undefined;
   isLoading: boolean;
   invalidate: () => Promise<void>;
}

export const UserContext = createContext<UserContextValue>({
   user: undefined,
   isLoading: false,
   invalidate: async () => {
      // no-op
   }
});
